<template>
  <div id="timeline-two"></div>
</template>
<script>
import { select } from 'd3'
import _ from 'lodash'
const getColor = d => {
  if (d.film) {
    return 'film-brown'
  }
  if (d.jetport) {
    return 'jetport-purple'
  }
  if (d.keyDate) {
    return 'key-date-pink'
  }
  if (d.iframeSrc) {
    return 'music-yellow'
  }
  return 'generic-grey'
}
const markDuplicates = dates => {
  const yearCounter = {}
  return dates.map(d => {
    const count = yearCounter[d.year] ?? 0
    yearCounter[d.year] = count + 1
    return { ...d, count }
  })
}
export default {
  name: 'TimelineTwo',
  mounted() {
    this.drawTimeline()
  },
  props: ['dates'],
  methods: {
    drawTimeline() {
      //mark duplicates
      const datesWithDupsMarked = markDuplicates(this.dates)
      console.log(datesWithDupsMarked)
      select('#timeline-two')
        .selectAll('.time-marker')
        .data(datesWithDupsMarked, d => d.year)
        .enter()
        .append('div')
        .attr('class', 'time-marker')
        .style('left', d => `${_.get(d.style, 'left', false) + d.count * 22}px`)
        .html(d => {
          const color = `var(--${getColor(d)})`
          const outlineColor = `var(--${getColor(d)}-outline)`
          if (_.get(d.pointerStyle, 'direction', 'down') === 'up') {
            return `<div class='circle' style="background-color: ${color}; border: 1.5px solid ${outlineColor}"}}></div>
          <span>${d.count === 0 ? d.year : ''}</span>
          <div class='pointer up' style="height: ${_.get(
            d.pointerStyle,
            'height'
          )}px;" />
          `
          }
          return `<div class='circle' style="background-color: ${color}; border: 1.5px solid ${outlineColor}"}}></div>
          <span>${d.count === 0 ? d.year : ''}</span>
          <div class='pointer' style="height: ${_.get(
            d.pointerStyle,
            'height'
          )}px;" />
          `
        })
    },
  },
}
</script>
<style>
#timeline-two {
  width: 10560px;
  height: 1.5px;
  background-color: var(--timeline-green);
  position: absolute;
  left: 5425px;
  top: 50%;
  z-index: 20;
}

#timeline-two .time-marker .pointer {
  width: 1px;
  background: linear-gradient(white, orange);
}
#timeline-two .time-marker .pointer.up {
  width: 1px;
  background: linear-gradient(orange, white);
  position: absolute;
  bottom: 65px;
}
</style>
